import { Bell, HelpCircle, Sun, Moon } from "lucide-react"
import { useAppStore } from "@/hooks/useAppStore"
import { getHealth } from "@/services/api"
import { SidebarTrigger } from "./Sidebar"
import { useEffect, useState } from "react"

export function Navbar() {
  const { theme, setTheme } = useAppStore()
  const [systemStatus, setSystemStatus] = useState<"online" | "offline">("offline")

  useEffect(() => {
    let cancelled = false
    getHealth()
      .then((res) => {
        if (!cancelled) setSystemStatus(res.data.status === "ok" ? "online" : "offline")
      })
      .catch(() => {
        if (!cancelled) setSystemStatus("offline")
      })
    return () => {
      cancelled = true
    }
  }, [])

  return (
    <header className="sticky top-0 z-30 flex h-12 shrink-0 items-center justify-between px-3 border-b border-border bg-graphite-800/80 backdrop-blur-lg">
      <div className="flex items-center gap-2">
        <SidebarTrigger />
        <span className="hidden md:block text-[0.625rem] font-mono text-dim tracking-wider">
          aerorocket.api › live
        </span>
      </div>

      <div className="flex items-center gap-3">
        <div className="flex items-center gap-2">
          <span className={`w-1.5 h-1.5 rounded-full ${systemStatus === "online" ? "bg-ok-500 animate-pulse-slow" : "bg-dim"}`} />
          <span className="text-[0.625rem] font-medium mono">
            {systemStatus === "online" ? "ONLINE" : "OFFLINE"}
          </span>
        </div>
        <div className="w-px h-3 bg-border mx-1" />

        <button
          onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
          className="p-1.5 rounded-sm text-dim hover:text-ink hover:bg-surface transition"
          title="Toggle theme"
          aria-label="Toggle theme"
        >
          {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
        </button>
        <button className="p-1.5 rounded-sm text-dim hover:text-ink hover:bg-surface transition" aria-label="Notifications">
          <Bell size={16} />
        </button>
        <button className="p-1.5 rounded-sm text-dim hover:text-ink hover:bg-surface transition" aria-label="Help">
          <HelpCircle size={16} />
        </button>
      </div>
    </header>
  )
}
